import { useState } from 'react';
import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';
import { useRolesCatalogue } from '../../roles/public/use-roles-catalogue';
import { buildUserColumns } from '../components/build-user-columns';
import { useUsers } from './use-users';

/** UsersPage's own state: the create drawer, and the columns built from `useUsers`'s row actions. */
export function useUsersPage() {
  const users = useUsers();
  const rolesCatalogue = useRolesCatalogue();
  const { state: currentUser } = useCurrentUser();
  const [createDrawerOpen, setCreateDrawerOpen] = useState(false);

  const roleOptions = rolesCatalogue.status === 'loaded' ? rolesCatalogue.roles : [];
  const columns = buildUserColumns({
    roleOptions,
    currentUserId: currentUser.status === 'authenticated' ? currentUser.user.id : undefined,
    list: users.list,
    onSetRoles: users.setRoles,
  });

  return { users, roleOptions, columns, createDrawerOpen, setCreateDrawerOpen };
}
